/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Button, CheckboxInput, Typography2 } from '@coursera/cds-core';
import { EditIcon, TrashIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/staff-management';

const styles = {
  container: css`
    background-color: var(--cds-color-emphasis-primary-background-strong);
    padding: var(--cds-spacing-150) var(--cds-spacing-300);
    border-radius: var(--cds-border-radius-100) var(--cds-border-radius-100) 0 0;
    width: 100%;
    display: flex;
    gap: var(--cds-spacing-300);
    align-items: center;
    position: sticky;
    top: 66px;
    z-index: 4;
  `,
  selectedCount: css`
    margin-right: auto;
  `,
};

export default function CDSTableBulkActions({
  selectedAll,
  selectedCount,
  onUnselect,
  onBatchEdit,
  onBatchDelete,
  ...props
}: {
  selectedAll: boolean;
  selectedCount: number;
  onUnselect: () => void;
  onBatchEdit: () => void;
  onBatchDelete: () => void;
}) {
  return (
    <div css={styles.container} {...props}>
      <CheckboxInput checked indeterminate={!selectedAll} onChange={onUnselect} />
      <Typography2 component="span" variant="actionPrimary" color="invertBody" css={styles.selectedCount}>
        {_t('#{count} selected', { count: selectedCount })}
      </Typography2>
      <Button variant="ghostInvert" icon={<EditIcon />} iconPosition="before" size="small" onClick={onBatchEdit}>
        {_t('Edit role')}
      </Button>
      <Button variant="ghostInvert" icon={<TrashIcon />} iconPosition="before" size="small" onClick={onBatchDelete}>
        {_t('Remove')}
      </Button>
    </div>
  );
}
